import axios from "axios";
import { baseUrl } from "../config/constants";

export const serviceCall = {
  signIn,
};
async function signIn(data) {
  try {
    const response = await axios.post(baseUrl + "/auth/signin", data);
    console.log(response.data);
    return response.data;
  } catch (error) {
    return error;
  }
}
